import { MutableRefObject } from 'react'

const sleep = (milliseconds: number) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

type RefHTMLElement = MutableRefObject<HTMLElement | null>

export const animateRemoteWorkChart = async (chartBackground: RefHTMLElement, percentRef: RefHTMLElement) => {
  for (let i = 0; i <= 90; i++) {
    chartBackground.current.style.setProperty("--progress", `${i}%`)
    percentRef.current.innerHTML = String(i)
    await sleep(Math.abs(i - 45) / 1.7) // ease-in-out
  }
}
